import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface FloatingCtaProps {
  onClick: () => void;
  price: string;
  originalPrice?: string;
  label?: string;
  showAfter?: number;
}
export function FloatingCta({
  onClick,
  price,
  originalPrice,
  label = 'ACTIVA TU ACCESO',
  showAfter = 600
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > showAfter);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showAfter]);
  return <AnimatePresence data-id="element-96" data-mp="boomv6t0415j">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-0 inset-x-0 z-40 pb-4 sm:pb-6 px-4 pointer-events-none" data-id="element-97" data-mp="195wujiubu1cl">
          <div className="max-w-2xl mx-auto pointer-events-auto" data-id="element-98" data-mp="2f4aizf4s24md">
            <div className="bg-black/80 backdrop-blur-2xl border border-white/15 rounded-2xl shadow-2xl shadow-black/60 p-3 sm:p-4 flex items-center gap-3 sm:gap-4 pr-20 sm:pr-24" data-id="element-99" data-mp="21cnl5av6so1h">
              {/* Price */}
              <div className="flex flex-col items-start min-w-0 pl-1" data-id="element-100" data-mp="1repvcixoij6r">
                <span className="text-[10px] sm:text-xs uppercase tracking-widest text-emerald-400 font-semibold" data-id="element-101" data-mp="1rgkkk9fzgxgn">
                  Hoy Solo
                </span>
                <div className="flex items-baseline gap-2" data-id="element-102" data-mp="1if358taegzt0">
                  <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-103" data-mp="1ncl4frym80nt">
                    {price}
                  </span>
                  {originalPrice && <span className="text-xs sm:text-sm text-white/40 line-through tabular-nums" data-id="element-104" data-mp="3csko42zv18hp">
                      {originalPrice}
                    </span>}
                </div>
              </div>

              {/* CTA */}
              <button onClick={onClick} className="ml-auto flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 active:bg-emerald-600 text-white font-bold text-sm sm:text-base px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-[0_0_30px_-8px_rgba(16,185,129,0.6)] ring-1 ring-emerald-400/40 transition-all duration-200 whitespace-nowrap" data-id="element-105" data-mp="3bandveaf7g9a">
                {label}
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-106" data-mp="2wwx4b71nca5" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}